// components/industry-templates/ComedyEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Laugh, Mic2, Star, Users } from 'lucide-react';

export const ComedyEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Comedians Lineup */}
      {industryData?.comedians && (
        <Card className="border-0 bg-gradient-to-br from-yellow-500/20 to-orange-500/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2 text-2xl">
              <Laugh className="w-8 h-8" style={{ color: theme.primary }} />
              Comedy Lineup
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {industryData.comedians.map((comedian: any, idx: number) => (
                <div key={idx} className="p-5 bg-white/10 rounded-xl border border-white/20">
                  <div className="flex items-start gap-4">
                    <div className="text-4xl">😂</div>
                    <div className="flex-1">
                      <div className="flex justify-between items-start mb-2">
                        <div>
                          <h3 className="text-2xl font-bold text-white">{comedian.name}</h3>
                          <p className="text-slate-300">{comedian.style}</p>
                        </div>
                        {comedian.headliner && (
                          <Badge className="bg-yellow-500 text-black">HEADLINER</Badge>
                        )}
                      </div>
                      <div className="flex gap-2 mt-3">
                        <Badge style={{ backgroundColor: theme.primary }}>
                          {comedian.performance_time}
                        </Badge>
                        <Badge variant="outline" className="border-white/20 text-white">
                          {comedian.duration}
                        </Badge>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Open Mic */}
      {industryData?.open_mic && (
        <Card className="border-2" style={{ borderColor: theme.primary, backgroundColor: 'rgba(245, 158, 11, 0.1)' }}>
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Mic2 className="w-6 h-6" style={{ color: theme.primary }} />
              Open Mic Session
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="bg-white/5 rounded-lg p-5">
              <p className="text-white text-lg mb-4">Try your comedy skills on stage!</p>
              <div className="grid grid-cols-3 gap-4">
                <div className="text-center p-3 bg-white/5 rounded-lg">
                  <p className="text-2xl font-bold" style={{ color: theme.primary }}>
                    {industryData.open_mic.slots}
                  </p>
                  <p className="text-xs text-slate-400">Available Slots</p>
                </div>
                <div className="text-center p-3 bg-white/5 rounded-lg">
                  <p className="text-2xl font-bold" style={{ color: theme.primary }}>
                    {industryData.open_mic.duration}
                  </p>
                  <p className="text-xs text-slate-400">Per Performer</p>
                </div>
                <div className="text-center p-3 bg-white/5 rounded-lg">
                  <p className="text-2xl font-bold text-white">
                    {industryData.open_mic.registration_required ? '✓' : '✗'}
                  </p>
                  <p className="text-xs text-slate-400">Pre-Register</p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Age Rating */}
      {industryData?.age_rating && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white">Important Information</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center gap-4">
              <Badge style={{ backgroundColor: theme.primary }} className="text-xl py-3 px-6">
                {industryData.age_rating}+
              </Badge>
              <p className="text-slate-300">Age Rating - Some content may not be suitable for all audiences</p>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Special Features */}
      {industryData?.features && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white">Show Features</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex flex-wrap gap-2">
              {industryData.features.map((feature: string, idx: number) => (
                <Badge key={idx} variant="outline" className="border-white/20 text-white text-sm py-2 px-4">
                  ✓ {feature}
                </Badge>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
